/**
 * Tool Confirmation Popup — Authorization Required modal
 * Shows when AI wants to execute a potentially dangerous action
 * Ported from ADA V2's ConfirmationPopup
 */
import React from 'react';
import { Shield } from 'lucide-react';

export default function ToolConfirmation({ request, onConfirm, onDeny }) {
  if (!request) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)',
    }}>
      <div style={{
        width: '480px', maxWidth: '90vw',
        padding: '32px',
        background: 'rgba(7,10,15,0.95)',
        border: '1px solid rgba(0,215,255,0.25)',
        borderRadius: '16px',
        boxShadow: '0 0 60px rgba(0,215,255,0.1)',
        fontFamily: 'var(--font-mono)',
      }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div style={{
            padding: '10px', borderRadius: '50%',
            background: 'rgba(0,215,255,0.1)',
            border: '1px solid rgba(0,215,255,0.3)',
            color: '#00D7FF',
          }}>
            <Shield size={22} />
          </div>
          <div>
            <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#00D7FF', letterSpacing: '0.15em' }}>
              AUTHORIZATION REQUIRED
            </div>
            <div style={{ fontSize: '9px', color: 'rgba(0,215,255,0.5)', letterSpacing: '0.2em' }}>
              AI CORE REQUEST
            </div>
          </div>
        </div>

        {/* Content */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{
            background: 'rgba(0,215,255,0.05)',
            border: '1px solid rgba(0,215,255,0.15)',
            borderRadius: '10px',
            overflow: 'hidden',
          }}>
            <div style={{
              padding: '8px 14px',
              background: 'rgba(0,215,255,0.08)',
              borderBottom: '1px solid rgba(0,215,255,0.1)',
              fontSize: '9px', color: 'rgba(0,215,255,0.7)',
              letterSpacing: '0.15em', textTransform: 'uppercase',
            }}>
              FUNCTION
            </div>
            <div style={{ padding: '12px 14px', fontSize: '16px', color: '#fff' }}>
              {request.tool || request.command || 'Unknown'}
            </div>
          </div>

          {request.args && (
            <div style={{
              marginTop: '8px',
              background: 'rgba(0,215,255,0.05)',
              border: '1px solid rgba(0,215,255,0.15)',
              borderRadius: '10px',
              overflow: 'hidden',
            }}>
              <div style={{
                padding: '8px 14px',
                background: 'rgba(0,215,255,0.08)',
                borderBottom: '1px solid rgba(0,215,255,0.1)',
                fontSize: '9px', color: 'rgba(0,215,255,0.7)',
                letterSpacing: '0.15em', textTransform: 'uppercase',
              }}>
                PARAMETERS
              </div>
              <div style={{ padding: '12px 14px' }}>
                <pre style={{
                  fontSize: '11px', color: 'rgba(185,243,255,0.7)',
                  whiteSpace: 'pre-wrap', margin: 0,
                }}>
                  {JSON.stringify(request.args, null, 2)}
                </pre>
              </div>
            </div>
          )}
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={onDeny}
            data-testid="confirm-deny"
            style={{
              flex: 1, padding: '12px',
              borderRadius: '10px',
              border: '1px solid rgba(255,59,59,0.3)',
              background: 'rgba(255,59,59,0.08)',
              color: '#FF3B3B',
              fontFamily: 'var(--font-mono)',
              fontSize: '11px', fontWeight: 'bold',
              letterSpacing: '0.15em', textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            DENY
          </button>
          <button
            onClick={onConfirm}
            data-testid="confirm-authorize"
            style={{
              flex: 1, padding: '12px',
              borderRadius: '10px',
              border: '1px solid rgba(0,215,255,0.3)',
              background: 'rgba(0,215,255,0.08)',
              color: '#00D7FF',
              fontFamily: 'var(--font-mono)',
              fontSize: '11px', fontWeight: 'bold',
              letterSpacing: '0.15em', textTransform: 'uppercase',
              cursor: 'pointer',
              boxShadow: '0 0 20px rgba(0,215,255,0.1)',
            }}
          >
            AUTHORIZE
          </button>
        </div>
      </div>
    </div>
  );
}
